define('modules/editor/views/property_boxes/html_content',['require','exports','module','./base','cm/lib/codemirror','cm/mode/htmlmixed/htmlmixed','ldsh!../../templates/property_boxes/html_content'],function(require, exports, module) {
  "use strict";

  var BasePropertyBox = require("./base"),
      CodeMirror = require("cm/lib/codemirror"),
      cmhtmlmixed = require("cm/mode/htmlmixed/htmlmixed");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/html_content"),
    events: {
      "click .js-request-content": "requestContent"
    },
    requestContent: function(){
      //this.model.set("content", this.codeEditor.getValue());
      this.model.parent.editHtml();
    },

    onRender: function(){
      this.$el.i18n();
    }
  });
});
